
import neoImg from '../assets/images/neo.png';
import niobeImg from '../assets/images/niobe.png';

const LoveStory = () => {
  const milestones = [
    {
      year: "2016",
      title: "Primer besito",
      description: "El dia que nos conocimos"
    },
    {
      year: "2020",
      title: "Nos fuimos a vivir juntos",
      description: "Pasamos la prueba de la pandemia"
    },
    {
      year: "2021",
      title: "Neo",
      description: "Llegó a nosotros un ser muy especial"
    },
    {
      year: "2022",
      title: "Niobe",
      description: "Otro ser muy especial se incorporó a nuestra familia"
    },
    {
      year: "2025",
      title: "Pedida super romántica",
      description: "Hincada de rodilla frente al mar en Nerja"
    },
    {
      year: "2026",
      title: "Celebración de nuestro amor",
      description: "Queremos compartir con vosotros un fin de semana lleno de momentos bonitos, ternura; y sobre todo, muchas risas. ¿Te apuntas?"
    }
  ];

  return (
    <section className="py-16 px-4 bg-white" style={{ backgroundImage: `url("${neoImg}"), url("${niobeImg}")`, backgroundPosition: 'left top, right top', backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }}>
      <div className="max-w-4xl mx-auto">
        <h2 className="font-great-vibes text-4xl text-center text-rose-600 mb-12">Un paseo romántico</h2>
        
        <div className="relative">
          <div className="absolute left-1/2 h-full w-0.5 bg-rose-200 transform -translate-x-1/2"></div>
          
          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <div 
                key={index} 
                className={`relative flex ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-start`}
              >
                <div className={`w-24 flex-shrink-0 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'} md:px-4`}>
                  <span className="inline-block px-3 py-1 bg-rose-600 text-white rounded-full">
                    {milestone.year}
                  </span>
                </div>
                
                <div className="absolute left-1/2 w-4 h-4 rounded-full bg-rose-600 transform -translate-x-1/2 mt-2"></div>
                
                <div className={`flex-1 bg-rose-50 p-6 rounded-lg shadow-sm ${index % 2 === 0 ? 'md:mr-8' : 'md:ml-8'}`}>
                  <h3 className="text-xl font-semibold text-rose-600 mb-2">{milestone.title}</h3>
                  <p className="text-gray-700">{milestone.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoveStory;